import api from './index'

export default function calculatePrice(employeesNumber, country, couponCode) {
  return api.get('/api/proposal/calculate', {
    params: { employeesNumber, couponCode, country },
  })
}
